import { bl_aat_claim_account_entitlement_employee_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class ClaimAccountEntitlementEmployeeFileHelperContainerModel extends BaseContainerModel {
    bl_aat_claim_account_entitlement_employee_import_file_helper: bl_aat_claim_account_entitlement_employee_import_file_helper_RowClass = new bl_aat_claim_account_entitlement_employee_import_file_helper_RowClass();


    
}